<template>
  <div :class="classes">
      <pt-page-title title="广告位详情">
          <template slot="before-left"  v-loading="positionLoading">
            <div :class="$style['banner-description']">广告位说明：{{extensionInfo.description}}</div>
            <div :class="$style['banner-description']">广告图片规则({{positionDetail.solo?'单个图片':"轮播图片"}})：{{extensionInfo.width+'px × '+extensionInfo.height+'px'}}</div>
          </template>
      </pt-page-title>
      <div :class="$style['banner-manage-detail']" v-loading="positionLoading">
          <table class="banner-manage-detail-table">
          <tr :class="$style['banner-manage-detail-item']"  v-for="(item,index) in form.banners" :key="index">
              <td>
               <wt-upload-file class="goods-banner-pictrue-upload" :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl"
                v-model="item.banner" data-vv-as="banner的图片" name="name" v-validate="'required'" :multiple="false" :height='extensionInfo.height/3' :width="extensionInfo.width/3">
                <div :class="$style['upload-file-text']" class="main-color">+</div>
            </wt-upload-file>
            </td>
            <td>
            <table :class="$style['banner-content']">
                <pt-form-list-item label="链接：">
                    <div :class="$style['banner-content-first']">
                        <wt-input v-model="item.url"  :class="$style['banner-content-url']"  data-vv-as="banner的链接" name="name" v-validate="'required'"></wt-input>
                        <el-button type="primary" @click="setMessage(item,index)">选择</el-button>
                        <el-button type="primary" @click="deleteBanner(index)">删除</el-button>
                    </div>
                </pt-form-list-item>
                <pt-form-list-item label="描述：">
                    <wt-input v-model="item.description"></wt-input>
                 </pt-form-list-item>
                  <pt-form-list-item label="检测项：" v-if="isShowDetetion">
                      <div>
                        <el-button type="primary" @click="selectDetection(item,index)">点击选择</el-button>
                        <div v-if="item.bannerList" :class="$style['detection-tags']">
                            <el-tag v-for="(atem,i) in item.bannerList" type="warning" :index="i" :key="atem.id" closable @close="deleteDetection(item,i)">{{atem.value}}</el-tag>
                        </div>
                    </div>
                 </pt-form-list-item>
            </table>
            </td>
          </tr>
          </table>
          <div class="button-div">
              <el-button type="primary" @click="addBanner" v-if="!positionDetail.solo">添加广告位图片</el-button>
              <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
          </div>
      </div>
      <el-dialog :visible="is_dialog" :title="dialog_title" class="message-dialog" @close="closeDialog">
          <message-set v-if="is_set" @selectSubmit="selectSubmit"  @close="closeDialog" bannerType="CAROUSEL" :currentItem="currentItem"></message-set>
          <select-for-detection  v-if="is_detection" selectDetectionTab="all" @close="closeDialog" @selectDetectionSubmit="selectDetectionSubmit" :selectDetetion="selectDetetion"></select-for-detection>
      </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import messageSet from './message-set'
import { isEmptyObject } from '@/utils/formUtils'
import selectForDetection from 'cps/mall-manage/select-for-detection'
import formMixins from 'mixins/form'
const prefixCls = 'pt-banner-detail'
export default {
  name: 'pt-banner-detail',
  mixins: [formMixins],
  components: {
    selectForDetection,
    messageSet
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      set: function (val) {
        this.is_set = val
        this.is_detection = val
      },
      get: function () {
        return this.is_set || this.is_detection
      }
    },
    extensionInfo () {
      return this.positionDetail.extensionInfo || {}
    },
    isNeedTrBorderBotton () {
      return true
    },
    // 是否加入检测项
    isShowDetetion () {
      return this.extensionInfo.tag
    }
  },
  props: {
    positionLoading: {
      type: Boolean,
      default: false
    },
    bannerList: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    positionDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'banner',
        objectId: 0
      },
      privateResourcesUrl: this.$publicResourcesUrl,
      form: {
        banners: [
        ]
      },
      is_set: false,
      dialog_title: '',
      selectIndex: '',
      detectionVisible: false,
      basePackageId: '',
      basePackageName: '',
      buildBase: true,
      is_detection: false,
      selectDetetion: [],
      currentItem: {}// 将当前对象传入到dialog中
    }
  },
  watch: {
    bannerList: {
      handler: function (val) {
        if (val.length > 0) {
          val.forEach(item => {
            this.form.banners.push(item)
          })
          // if (this.positionDetail.hasOwnProperty('solo') && !this.positionDetail.solo) {
          //   this.form.banners.push({})
          // }
        } else {
          this.form.banners.push({})
        }
      }
    }
  },
  methods: {
    selectDetectionSubmit (val) {
      this.is_detection = false
      this.form.banners.forEach((item, index) => {
        if (index === this.selectIndex) {
          item.bannerList = item.bannerList || []
          if (val && val.length > 0) {
            val.forEach(etem => {
              item.bannerList.push({
                contentId: etem.id,
                value: etem.chineseName
              })
            })
          }
        }
      })
    },
    deleteDetection (val, i) {
      val.bannerList.splice(i, 1)
      if (val.bannerList.length === 0) {
        val.bannerList = null
      }
      this.form.banners.sort()
    },
    selectDetection (item, index) {
      this.selectIndex = index
      this.selectDetetion = []
      this.form.banners.forEach((item, index) => {
        if (index === this.selectIndex) {
          if (item.bannerList && item.bannerList.length > 0) {
            item.bannerList.forEach(item => {
              this.selectDetetion.push({ id: item.contentId, chineseName: item.value })
            })
          }
        }
      })
      this.is_detection = true
      this.dialog_title = '查看检测项'
    //   this.
    },
    deleteBanner (index) {
      this.form.banners.splice(index, 1)
    },
    closeDialog () {
      this.is_set = false
      this.is_detection = false
    },
    selectSubmit (val) {
      this.form.banners.forEach((item, index) => {
        if (index === this.selectIndex) {
          item.url = val.url
          item.description = val.description
          // item.banner = val.banner
          item.type = val.type
          item.title = val.title
          item.resourceName = val.resourceName
          item.resourceId = val.resourceId
          item.recordId = val.recordId
          this.is_set = false
        }
      })
    },
    addBanner () {
      let flag = true
      this.form.banners.forEach(item => {
        if (isEmptyObject(item)) {
          flag = false
        }
      })
      if (flag) {
        this.form.banners.push({})
      } else {
        this.$message.error('请先填写空白的广告位信息')
      }
    },
    submit () {
      this.validate().then(res => {
        this.$emit('submit', this.form)
      })
    },
    setMessage (val, index) {
      this.currentItem = val
      this.is_set = true
      this.selectIndex = index
      this.dialog_title = '信息设置'
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.detection-tags{
    width:100%;
    margin-top: 10px;
    :global
    .el-tag{
        margin-right: 10px;
        margin-bottom: 10px;
    }
}
.banner-manage-detail{
    // display: flex
}
.banner-description{
    line-height: 25px;
    color: red;
    font-size: 14px
}
.banner-manage-detail-item{
    display: table-row;
    border-bottom: 1px solid #C6C9D3;
    &.banner-manage-detail-item{
        margin-top: 20px
    }
    :global
    .goods-banner-pictrue-upload{
        margin-bottom: 20PX;
        width: 100%;
        height:100%;
        .el-upload--picture-card{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
        }
        .el-upload-list__item{
            margin: 0;
            .el-upload--picture-card;
            box-sizing:inherit
        }
    };
    :global
    .wt-input{
        display: block;
        flex: 1
    }
}
.upload-file-text{
    font-size: 50px
}
.banner-content{
    padding-left: 30px;
    width: 100%;
    :global
    tr{
        display:table-row!important;
        td{
            display: table-cell!important;
            &:first-child{
                display: flex!important;
            }
        }
    }
}
.banner-content-first{
    display: flex;
    width: 100%
}
.banner-content-url{
    margin-right: 40px;
    max-width: 500Px;
}
.message-dialog{
    :global
    .el-dialog{
        min-width: 1000PX;
    }
}
</style>
<style lang="less">
.pt-banner-detail{
    .banner-manage-detail-table{
        width:100%;
        max-width: 700PX;
        display: initial;
        tr{
            display:flex;
            flex:1;
            td{
                display:flex;
                &:last-child{
                    flex:1
                }
            }
        }
    }
}
</style>
